const steps = [
  {
    num: "01",
    title: "Find Products",
    desc: "Browse 5000+ products across 14 categories in the latest VigorBuy spreadsheet and discover exactly what you are looking for.",
    icon: "ri-search-line",
  },
  {
    num: "02",
    title: "Check QC",
    desc: "Review detailed QC photos and seller verification status to ensure you are buying from trusted sources with proven quality.",
    icon: "ri-shield-check-line",
  },
  {
    num: "03",
    title: "Compare Sellers",
    desc: "Compare prices, shipping options, and seller ratings across our verified network to find the best deal for every product.",
    icon: "ri-scales-line",
  },
  {
    num: "04",
    title: "Place Order",
    desc: "Use our direct links to place your order on the main site with confidence, knowing you have done thorough research.",
    icon: "ri-shopping-bag-line",
  },
];

export default function HowItWorks() {
  return (
    <section id="how-it-works" className="w-full py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        {/* Header */}
        <div className="text-center mb-12">
          <p className="text-xs font-semibold uppercase tracking-wider text-accent-600 mb-2">How It Works</p>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            Start Shopping Smarter in <span className="text-accent-500">4 Simple Steps</span>
          </h2>
          <p className="text-sm text-foreground-600 mt-2 max-w-lg mx-auto">
            Using the VigorBuy spreadsheet is easy, even for complete beginners
          </p>
        </div>

        {/* Steps Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {steps.map((step) => (
            <div
              key={step.num}
              className="bg-background-50 rounded-xl p-6 md:p-7 relative group hover:-translate-y-1 transition-all duration-300"
            >
              {/* Number */}
              <div className="text-5xl md:text-6xl font-bold text-background-200 font-heading mb-4 select-none">
                {step.num}
              </div>
              {/* Icon */}
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 mb-4">
                <i className={`${step.icon} text-lg`}></i>
              </div>
              {/* Text */}
              <h3 className="text-base font-semibold text-foreground-950 font-heading mb-2">{step.title}</h3>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">{step.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}